import { render } from "./manageKPI.vue?vue&type=template&id=08f73204&scoped=true&ts=true"
import script from "./manageKPI.vue?vue&type=script&lang=ts"
export * from "./manageKPI.vue?vue&type=script&lang=ts"

import "./manageKPI.vue?vue&type=style&index=0&id=08f73204&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f73204"]])

export default __exports__